<template>
  <div class="d-flex align-center logo-upload-field">
    <v-text-field
      :value="value"
      :label="label"
      class="flex-grow-1 mr-2"
      hide-details="auto"
      @input="$emit('input', $event)"
    ></v-text-field>
    <v-btn
      icon
      small
      :loading="uploading"
      :disabled="disabled || uploading"
      :title="
        disabled ? 'Save first, then upload a logo image' : 'Upload logo image'
      "
      @click="$refs.fileInput.click()"
    >
      <v-icon small>mdi-upload</v-icon>
    </v-btn>
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      class="d-none"
      @change="onNativeFileChange"
    />
  </div>
</template>

<script>
export default {
  name: 'LogoUploadField',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Logo url'
    },
    // Vuex action path (e.g. 'OrganizationStore/uploadLogo') that finalizes the
    // upload for this owner - dispatched with { id: ownerId, tempFileName }.
    uploadAction: {
      type: String,
      required: true
    },
    ownerId: {
      type: [Number, String],
      default: null
    },
    // True before the owning record has been saved once (no id yet) - a logo
    // upload needs a real id to know where to store the file.
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploading: false
    }
  },
  methods: {
    onNativeFileChange(e) {
      const file = e.target.files && e.target.files[0]
      // Reset so picking the same file again still fires a change event.
      e.target.value = ''
      this.onFileSelected(file)
    },
    async onFileSelected(file) {
      if (!file) return
      this.uploading = true
      try {
        const formData = new FormData()
        formData.append('file0', file, file.name)
        const uploadRes = await this.$store.dispatch('MediaStore/uploadFiles', {
          files: formData
        })
        const tempFileName = uploadRes.data[0].tempName
        // th-server stores/serves the file under a path relative to itself
        // (/attachments/<owner>-<id>/...), but the backoffice and th-server
        // aren't reliably same-origin (cross-port in dev; different reverse-
        // proxy prefix per environment in staging/prod - VUE_APP_API_URL
        // already encodes the right one). Passing it along lets the server
        // store an immediately-usable URL, same as every other logo field.
        const baseUrl = (process.env.VUE_APP_API_URL || '').replace(
          /\/api\/v1\/?$/,
          ''
        )
        const updated = await this.$store.dispatch(this.uploadAction, {
          id: this.ownerId,
          tempFileName,
          baseUrl
        })
        this.$emit('input', updated.logo)
      } catch (e) {
        this.$store.dispatch('NotificationStore/add', {
          type: 'error',
          message: 'Could not upload logo image'
        })
      } finally {
        this.uploading = false
      }
    }
  }
}
</script>
